<template>
  <el-dialog
    title="导入数据"
    :visible.sync="dialogdata"
    width="620px"
    style="text-align: left"
    :close-on-click-modal="false"
    @open="opendialog"
  >
    <div class="uploadbox">
      <div style="margin-bottom: 20px">
        <span>选择药房</span>
        <el-select
          v-model="hospital_id"
          placeholder="请选择"
          style="width: 400px; margin-left: 10px"
        >
          <el-option
            v-for="item in hospitalList"
            :key="item.value"
            :label="item.hospital_name"
            :value="item.hospital_id"
          >
          </el-option>
        </el-select>
      </div>
      <el-upload
        class="avatar-uploader"
        name="image"
        :action="uploadUrl"
        :data="uploadExtraData"
        :headers="uploadHeaders"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeUpload"
      >
        <el-button
          plain
          v-if="file_name"
          size="medium"
        >重新选择</el-button>
        <el-button
          type="primary"
          v-else
          size="medium"
          :disabled="!hospital_id"
        >选择文件</el-button>
      </el-upload>
      <div
        class="filebox"
        v-if="file_name"
      >
        <div>
          <span>上传文件：</span>
          <span style="color: #666">{{ file_name }}</span>
        </div>
        <div style>
          <span>文件大小：</span>
          <span style="color: #666">{{ file_size }}kb</span>
        </div>
        <div>
          <span>成功条数：</span>
          <span style="color: #666">{{ success_count }}条</span>
        </div>
        <div v-if="fail_count">
          <span>错误数据：</span>
          <span style="color: #ff514b">{{ fail_count }}条，行数：{{ fail_row }}</span>
        </div>
      </div>
      <div class="msgbox">
        <el-button
          type="text"
          style="font-weight: 600"
          @click="download"
        >下载药品模板</el-button>
        <ul style="color: #999">
          <li>请按照模板格式完整填写数据后导入，否则无法导入</li>
          <li>已创建药品无法再次导入</li>
          <li>最大支持1MB的CSV或Excel文件</li>
          <li>错误数据可对照文件行数修改数据后重新导入</li>
          <li>导入商品需要时间，请耐心等待</li>
        </ul>
      </div>
    </div>
    <div style="text-align: right; padding: 0 20px 20px 0; box-sizing: border-box">
      <el-button
        type="primary"
        @click="close"
        style="width: 92px"
        size="medium"
      >确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import constant from '../../../service/common/constant';
import axios from '../../../service/axios/axios';
export default {
  data() {
    return {
      dialogdata: false,
      uploadExtraData: {
        img_type: 6,
        suffix: '.jpg'
      },
      file_name: '',
      file_size: '',
      success_count: '',
      fail_count: '',
      fail_row: '',
      hospital_id: '',
      hospitalList: []
    };
  },
  watch: {
    isFlag() {
      this.dialogdata = true;
    }
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return '/api/platform/upload/uploadFile';
      } else {
        return '/platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  props: ['isFlag'],
  methods: {
    //提交
    close() {
      this.dialogdata = false;
      this.$emit('refreshList');
    },
    //上传之前
    beforeUpload(file) {
      const isText = file.type === 'application/vnd.ms-excel';
      const isTextComputer =
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isText && !isTextComputer) {
        this.$message.error('上传文件只能是CSV或Excel文件');
        return false;
      }
      if (!isLt1M) {
        this.$message.error('最大支持1MB的文件!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      return (isText && isLt1M) || (isTextComputer && isLt1M);
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      let loading = this.$loading();
      if (res.code === 0) {
        loading.close();
        let data = {
          hospital_id: this.hospital_id,
          goods_pic: res.data.pic
        };
        this.axios
          .post('platform/Goods/importHospitalGoods', data)
          .then((res) => {
            if (res.code == 0) {
              this.file_name = file.name;
              this.file_size = (file.size / 1024).toFixed(2);
              this.success_count = res.data.success_row_count;
              this.fail_count = res.data.fail_row_count;
              this.fail_row = res.data.row;
            }
          });
      } else {
        loading.close();
        this.$message.error(res.message);
      }
    },
    //下载药品模板
    download() {
      let host =
        document.location.protocol +
        '//' +
        window.location.host +
        '/upload/drug_template_platform.xls';
      location.href = host;
    },
    //获取药房列表
    getHospital() {
      this.axios
        .post('platform/hospital/getHospitaList', {
          page: 1,
          pageNumber: 10000
        })
        .then((res) => {
          this.hospitalList = res.data.list;
        });
    },
    opendialog() {
      this.file_name = '';
      this.file_size = '';
      this.success_count = '';
      this.fail_count = '';
      this.fail_row = '';
      this.getHospital();
    }
  }
};
</script>
<style lang="scss" scoped>
.uploadbox {
  padding: 30px 40px;
  box-sizing: border-box;
}
.filebox {
  line-height: 32px;
}
</style>
